/**
 * Checks if v is proper falsy, not like 0.
 * @param v 
 * @returns boolean
 */
export function falsy(v: any): boolean {
  return v === undefined || v === null || v === '' || v === false;
}

/**
 * Checks if v is truthy.
 * @param v 
 * @returns boolean
 */
export function truthy(v: any): boolean {
  return v !== undefined && v !== null && v !== '';
}

/**
 * Checks if 2 strings are equal.
 * @param a string
 * @param b string
 * @returns boolean
 */
export function strcmp(a = "a", b = "b"): boolean {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}

/**
 * Checks if n is an int.
 * @param n number
 * @returns boolean
 */
export function isInt(n: number): boolean {
    return n % 1 === 0;
}

/**
 * Generates a random int between min and max.
 * @param min number
 * @param max number
 * @returns number
 */
export function randomInt(min: number, max: number): number {
  return Math.round(Math.random() * (max - min) + min);
}

/**
 * Checks if n is a float.
 * @param n number
 * @returns boolean
 */
export function isFloat(n: number){
    return n % 1 !== 0;
}

/**
 * Generates a random float between min and max up to x decimals.
 * @param min number
 * @param max number
 * @param decimals number
 * @returns number
 */
export function randomFloat(min: number, max: number, decimals: number): number {
  const str = (Math.random() * (max - min) + min).toFixed(
    decimals,
  );
  return parseFloat(str);
}

export function toMap<T extends { id: number | string }>(arr: T[]) {
  const map = new Map<number | string, T>();
  arr.forEach(o => {
    map.set(o.id, o);
  });
  return map;
}
